<template>
  <div class="boolean-component">
    <div class="boolean-row">
      <div class="boolean-label">
        {{ label }}
      </div>
      <div class="boolean-options">
        <label
            class="boolean-option"
            :class="{ active: value[config] === true }"
        >
          <input
              type="radio"
              :name="config"
              :value="true"
              v-model="value[config]"
              class="boolean-input"
          >
          <span class="option-text">Sim</span>
        </label>
        <label
            class="boolean-option"
            :class="{ active: value[config] === false }"
        >
          <input
              type="radio"
              :name="config"
              :value="false"
              v-model="value[config]"
              class="boolean-input"
          >
          <span class="option-text">Não</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BOOLEAN_COMPONENT",
  props: [
    'value',
    'config',
    'label',
  ]
};
</script>

<style scoped>
.boolean-component {
  margin-bottom: 16px;
}

.boolean-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f1f3f4;
}

.boolean-row:last-child {
  border-bottom: none;
}

.boolean-label {
  font-weight: 500;
  color: #495057;
  font-size: 14px;
  flex: 1;
}

.boolean-options {
  display: flex;
  gap: 8px;
}

.boolean-option {
  cursor: pointer;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 6px 12px;
  transition: all 0.2s ease;
  background: white;
  font-size: 13px;
  min-width: 50px;
  text-align: center;
  position: relative;
}

.boolean-option:hover {
  border-color: #3a3e81;
  background-color: #f8f9ff;
}

.boolean-option.active {
  border-color: #3a3e81;
  background-color: #3a3e81;
  color: white;
}

.boolean-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.option-text {
  font-weight: 500;
  pointer-events: none;
}
</style>